import { render, staticRenderFns } from "./RegisterAsset.vue?vue&type=template&id=408f8dd2&"
import script from "./RegisterAsset.vue?vue&type=script&lang=js&"
export * from "./RegisterAsset.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAsset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports